<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-2" width="100%">
    <v-expansion-panel-header
      color="#708e92"
      class="white--text"
      style="width: 100%"
    >
      <template v-slot:actions>
        <v-icon color="white"> $expand </v-icon>
      </template>
      Public Resources
    </v-expansion-panel-header>
    <v-expansion-panel-content class="grey lighten-5">
      <v-row>
        <c-col id="resources">
          <v-card elevation="2" tile class="mt-8 mb-4">
            <v-card-text class="black--text">
              <span
                ><a
                  href="https://www.communitynotification.com/cap_main.php?office=54696"
                  target="_blank"
                  title="Regional Sex Offender Notification Unit (RSONU)"
                  >Regional Sex Offender Notification Unit Website</a
                ></span
              ><br /><br />
              <span
                ><a
                  href="https://www.nsopw.gov/"
                  target="_blank"
                  title="National Sex Offender Public Website"
                  >National Sex Offender Public Website</a
                ></span
              ><br /><br />
              <span
                ><a
                  href="https://sexoffenders.nv.gov"
                  target="_blank"
                  title="Nevada Sex Offender Registry Website"
                  >Nevada Sex Offender Registry Website</a
                ></span
              ><br /><br />
              <span
                ><a
                  href="https://www.familywatchdog.us/"
                  target="_blank"
                  title="Family Watchdog"
                  >FAMILY WATCHDOG</a
                ></span
              >
            </v-card-text>
          </v-card>
        </c-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style scoped>
.bcs-expansion-content {
  color: black;
}
.howwrap {
  word-break: break-word;
}

@media (min-width: 0px) {
  #resources {
    width: 100%;
  }

  #resources a {
    color: #039be5;
    font-size: 0.8 rem !important;
    text-decoration: underline;
    font-weight: 600;
    text-transform: uppercase;
  }
  #resources a:visited {
    color: #006597 !important;
  }
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "resources",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
